// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1S4ArPAsHLcphBeOJY7QPt {\n  width: 100%;\n  margin: 0 auto;\n}\n\n@media (max-width: 767px) {\n  ._1S4ArPAsHLcphBeOJY7QPt {\n    width: 100%;\n  }\n}\n", ""]);
// Exports
exports.locals = {
	"research": "_1S4ArPAsHLcphBeOJY7QPt"
};
module.exports = exports;
